import React, { Component } from 'react'
import queryString from 'query-string'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { companyFragment, viewerFragment, ownerFragment } from 'fragments'
import BusinessLayout from 'components/layouts/BusinessLayout/home'
import Path from 'routes/path'

class SignupDoneContainer extends Component<*> {
  renderConfirmed = () => {
    const { data, config, ui, location } = this.props
    const currentUser = data.viewer
    const username = queryString.parse(location.search).company
    const startUrl = `${config.ORIGIN}/companies/${username}/setting`

    return (
      <BusinessLayout
        title={i18n.t('server.business.signupdone.title')}
        description={i18n.t('server.business.signupdone.description')}
        {...this.props}
      >
        <div className="site-main site-business__main">
          <div className="pt40">
            <div className="page__col1">
              <div className="signup-head">
                <h1 className="page-title">法人アカウント登録完了</h1>
                {currentUser ? (
                  <ul className="signup-step mb20">
                    <li className="signup-step__status1 business-signup-step__status2">
                      <span className="sm-hide">法人情報</span>入力
                    </li>
                    <li className="signup-step__status3 is-current">
                      <span className="sm-hide">登録</span>完了
                    </li>
                    <li className="signup-step__status2">
                      <span className="sm-hide">メールアドレスの</span>確認
                    </li>
                  </ul>
                ) : (
                  <ul className="signup-step business-signup__step mb20">
                    <li className="signup-step__status1">
                      <span className="sm-hide">アカウント</span>登録
                    </li>
                    <li className="signup-step__status3 is-current">
                      <span className="sm-hide">登録</span>完了
                    </li>
                    <li className="signup-step__status2 business-signup-step__status2">
                      <span className="sm-hide">法人情報</span>入力
                    </li>
                    <li className="signup-step__status2">
                      <span className="sm-hide">メールアドレスの</span>確認
                    </li>
                  </ul>
                )}
              </div>
              <div className="signup-box">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="signup-box__wrapper">
                      <p className="signup-box__notes ta-c">
                        法人アカウント登録ありがとうございます。
                      </p>
                    </div>
                  </div>
                  <div className="col-xs-12 ta-c mt20">
                    <a
                      href={Path.loginAccount(config.URL || '')}
                      className="button-green pt15 pb15 w280 sm-w100"
                    >
                      ログインする
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BusinessLayout>
    )
  }

  renderNeedConfirm = () => {
    const { ui, user, data, config, location } = this.props
    const currentUser = data.viewer
    const paidForm = ui.paidForm || {}

    if (!ui.isSuccessRegister) {
      return <Redirect to={Path.signup()} />
    }

    return (
      <BusinessLayout
        title={i18n.t('server.business.setting.title')}
        {...this.props}
      >
        <div className="site-main site-business__main">
          <div className="pt40">
            <div className="page__col1">
              <div className="signup-head">
                <h1 className="page-title">ご登録メールアドレスの確認</h1>
                {currentUser ? (
                  <ul className="signup-step mb20">
                    <li className="signup-step__status1 business-signup-step__status2">
                      <span className="sm-hide">法人情報</span>入力
                    </li>
                    <li className="signup-step__status3">
                      <span className="sm-hide">登録</span>完了
                    </li>
                    <li className="signup-step__status2 is-current">
                      <span className="sm-hide">メールアドレスの</span>確認
                    </li>
                  </ul>
                ) : (
                  <ul className="signup-step business-signup__step mb20">
                    <li className="signup-step__status1">
                      <span className="sm-hide">アカウント</span>登録
                    </li>
                    <li className="signup-step__status3">
                      <span className="sm-hide">登録</span>完了
                    </li>
                    <li className="signup-step__status2 business-signup-step__status2">
                      <span className="sm-hide">法人情報</span>入力
                    </li>
                    <li className="signup-step__status2 is-current">
                      <span className="sm-hide">メールアドレスの</span>確認
                    </li>
                  </ul>
                )}
              </div>
              <div className="signup-box">
                <div className="row">
                  <div className="col-xs-12">
                    <h2 className="signup-box__title signup-box__title-other">
                      メール送信完了
                    </h2>
                    <div className="signup-box__wrapper">
                      <p className="signup-box__notes ta-c">
                        スペースマーケットにご登録いただきまして、誠にありがとうございます！
                        <br />
                        下記メールアドレスに確認メールを送信しました。
                      </p>
                      <div className="signup-box__mailcheck">
                        <p className="mb20">
                          <span className="sm-signup-box__mailcheck__title">
                            個人メールアドレス：
                          </span>
                          {user.email}
                        </p>
                        <p>
                          <span className="sm-signup-box__mailcheck__title">
                            会社メールアドレス：
                          </span>
                          {paidForm.email}
                        </p>
                      </div>
                      {currentUser ? (
                        <p className="signup-box__notes ta-c">
                          メールに記載のリンクをクリックし、ログインしてください。
                        </p>
                      ) : (
                        <p className="signup-box__notes ta-c">
                          アカウント登録を完了するには24時間以内にメールに記載のリンクを
                          <br className="sm-hide" />
                          クリックしアカウントを承認してください。
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BusinessLayout>
    )
  }

  render() {
    const { data, config, ui, location } = this.props
    const currentUser = data.viewer
    const username = queryString.parse(location.search).company

    if (username) return this.renderConfirmed()
    else return this.renderNeedConfirm()
  }
}

const withData = graphql(
  gql`
  query BusinessSignupContainer {
    viewer {
      ${viewerFragment}
      companies(filter: MANAGED) {
        results {
          ... on Company {
            ${companyFragment}
          }
        }
      }
    }
  }
`,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {},
    }),
  },
)(SignupDoneContainer)

function mapStateToProps(state) {
  return state
}
export default withRouter(connect(mapStateToProps)(withData))
